import { Fragment, useEffect, useState } from "react";
import { ExportFileContainer } from "./RightOptions/exportFileContainer";
import { PriceTablePopup } from "./RightOptions/priceTablePopup";
import { WishListContainer } from "./RightOptions/wishListContainer";
import { useLocation } from "react-router-dom";

export const ToolbarContainer = ({ product, cartItem, showPriceTable = false, showPrint = false }) => {
  const [prodDetail, setProdDetail] = useState(null);
  useEffect(() => {
    if (product) {
      setProdDetail(product);
    }
  }, [product]);

  return (
    <Fragment>
      {prodDetail && (
        <Fragment>
          <WishListContainer prd={cartItem} />
          {showPrint && <ExportFileContainer prd={prodDetail} />}
          {showPriceTable && <PriceTablePopup params={prodDetail} />}
        </Fragment>
      )}
    </Fragment>
  );
};
